import PropTypes from "prop-types";
import { Row, Select, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";

const options = [
  {
    id: "paid",
    name: "Lunas",
  },
  {
    id: "pending",
    name: "Belum Bayar",
  },
];

const mergeUniqueById = (prevData, newData) => {
  const existingIds = new Set(prevData.map((item) => item.id));
  return [
    ...prevData,
    ...newData.filter((item) => !existingIds.has(item.id)),
  ];
};

const SelectStatusPayment = ({ value, onChange, readOnly }) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getStatus = useCallback(async () => {
    setLoading(true);
    const newData = options;
    setListData((prevData) => mergeUniqueById(prevData, newData));
    setLoading(false);
  }, []);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  return (
    <Select
      style={
        readOnly ? { pointerEvents: "none", width: "100%" } : { width: "100%" }
      }
      allowClear={!readOnly}
      showSearch={!readOnly}
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Status"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
      }))}
      open={readOnly ? false : undefined}
    />
  );
};


SelectStatusPayment.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  readOnly: PropTypes.any,
};

export default SelectStatusPayment;
